import { VStack } from 'tio-ui/components/layout';
import GuidedWizard from 'tio-employee/components/tas/applications/guided/wizard';
import type { TOC } from '@ember/component/template-only';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { TasProgramInstanceExtension as TASProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';
import type { TasUnifiedInstitution as TasUnifiedInstitutionModel } from 'tio-data/data/resources/tas-unified-institution.type';

export interface S {
  Args: {
    model: {
      application: TasApplicationModel;
      programInstance: TASProgramInstanceModel;
      selectedSchool: TasUnifiedInstitutionModel | undefined;
    };
  };
}

const tmpl: TOC<S> = <template>
  <VStack>
    <GuidedWizard @model={{@model}} @typeClassification="TAS.ProgramType.2" />
  </VStack>
</template>;

export default tmpl;
